// @ts-nocheck
const CustomerInvoiceList = () => {
    return (
        <div>CustomerInvoiceList</div>
    )
}

export default CustomerInvoiceList